import styled from "styled-components/macro";

export const BannerContainer = styled.div`
    box-sizing: border-box;
    position: relative;
    display: flex;
    direction: rtl;
    flex-direction: column;
    width: 100%;
    padding: 1em;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 0;
`;

export const BannerTitle = styled.span`
    font-size: 1rem;
    line-height: 24px;
    font-weight: 600;
    margin-left: 6rem;
    white-space: pre-line;
`

export const BannerText = styled.span`
    font-size: 0.75rem;
    opacity: 0.75;
    max-width: 275px;
    margin-left: 8rem;
    white-space: pre;
`

export const BannerButtonWrapper = styled.div`
    margin-top: auto;
    padding-top: 0.75rem;
`

export const BannerButtonBody = styled.div`
    border-radius: 16px;
    padding: 4px 12px;
    width: fit-content;
    display: flex;
    direction: rtl;
    cursor: pointer;
`

export const BannerButtonTitle = styled.span`
    font-size: 0.875rem;
    line-height: 24px;
    font-weight: 500;
`

export const BannerButtonIcon = styled.div`
    margin-right: 0.5rem;
    height: 24px;
    padding-top: 2px;
`

export const BannerImage = styled.img`
    position: absolute;
    width: 160px;
    bottom: 0;
    left: 0;
`